import axios from "axios";
import store from '../store';

axios.interceptors.request.use(
  (config) => {
    const token = store.state.auth.accessToken 

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default {
  async logout() {
    return axios.post("/api/enduser/logout", {
      refresh_token: store.state.auth.refreshToken,
    });
  },
  async getNews(params = {}) {
    return axios.get(`/api/enduser/news`, { params });
  },

  async getLocalBalance() {
    return axios.get(`/api/enduser/balance`);
  },
  async getRemoteBalance() {
    return axios.get(`/api/enduser/balance/mse`);
  },
  async getShareBalance() {
    return axios.get(`/api/enduser/balance/shares`);
  },
  async profile() {
    return axios.get(`/api/enduser/user`);
  },
  async tradeHistory(params = {}) {
    return axios.get(`/api/enduser/sold/trade`, { params });
  },
  async tradeAllHistory(params = {}) {
    return axios.get(`/api/enduser/sold/trade/all`, { params });
  },
  async orderHistory(params = {}) {
    return axios.get(`/api/enduser/sold/order`, { params });
  },
  async openOrders(params = {}) {
    return axios.get(`/api/enduser/orders/open`, { params });
  },
  async brandList(params = {}) {
    return axios.get(`/api/enduser/brands`, { params });
  },
  async symbolOCHL(symbol) {
    return axios.get(`/api/enduser/ochl/${symbol}`);
  },
  async favoriteBrands(params = {}) {
    return axios.get(`/api/enduser/favorite/brands`, params);
  },
  async exchangeServers(params = {}) {
    return axios.get(`/api/enduser/exchange-servers`, params);
  },

  async addFavoriteBrand(model) {
    return axios.post(`/api/enduser/brands/favorite`, model);
  },
  async removeFavoriteBrand(params = {}) {
    return axios.delete(`/api/enduser/brands/favorite`, { params });
  },

  async buy(model) {
    return axios.post(`/api/enduser/order/buy`, model);
  },
  async sell(model) {
    return axios.post(`/api/enduser/order/sell`, model);
  },
  async cancelOrder(order) {
    return axios.post(`/api/enduser/order/${order.id}/cancel`, order);
  },
  async getFees() {
    return axios.get(`/api/enduser/get-fees`);
  },

  async getChartPrice(params = {}) {
    return axios.get(`/api/closing/price`, { params });
  },

  async getUserFinalities(params) {
    return axios.get(
      `/api/enduser/transaction/mse/${params.from}/${params.to}?page=${params.page}`,
    );
  },

  async getUserFinalitiesNonPage(params, type) {
    return axios.get(
      `/api/enduser/transaction/mse/${params.from}/${params.to}/non`,
    );
  },

  async getTotalProfits() {
    return axios.get(`/api/enduser/profit/total`);
  },

  async getSymbolProfits() {
    return axios.get(`/api/enduser/profit/symbol`);
  },
};
